import { observer } from "mobx-react-lite";
import { Fragment, useEffect } from "react";
import { LoginStore } from "../../store";
import { useNavigate } from "react-router-dom";
import { useHandleSignInCallback } from "@logto/react";
import { Spin } from "antd";

function ConfirmLogin() {
  const navigate = useNavigate();
  const { isLoading } = useHandleSignInCallback(() => {
    LoginStore.jwtLogin(
      window.localStorage.getItem(
        "logto:" + LoginStore.config.appId + ":idToken"
      )
    );
  });

  useEffect(() => {
    if (window.location.href.indexOf("?code=") < 0) {
      navigate("/login");
    }
  }, []);
  return (
    <Fragment>
      {isLoading && (
        <Spin tip="登录中" size="large" style={{ marginTop: "40vh" }}>
          <div className="content" />
        </Spin>
      )}
    </Fragment>
  );
}

export default observer(ConfirmLogin);
